import { render, staticRenderFns } from "./SideBarPostsTab.vue?vue&type=template&id=3c3072cb&scoped=true&"
import script from "./SideBarPostsTab.vue?vue&type=script&lang=js&"
export * from "./SideBarPostsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3072cb",
  null
  
)

export default component.exports